// Presentational chart block for the dashboard page.
import BarChart from '@/features/dashboard/components/BarChart';
import ProjectBreakdown from '@/features/dashboard/components/ProjectBreakdown';

export function DashboardChartSection({
  barData,
  onDayClick,
  canGoBack,
  canGoForward,
  onPreviousWeek,
  onNextWeek,
  projectData,
  projectFilter,
  onProjectClick,
}) {
  return (
    <>
      <BarChart
        barData={barData}
        onDayClick={onDayClick}
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        onPreviousWeek={onPreviousWeek}
        onNextWeek={onNextWeek}
      />
      <ProjectBreakdown
        projects={projectData}
        selectedProject={projectFilter}
        onProjectClick={onProjectClick}
      />
    </>
  );
}
